import { useEffect } from "react";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { autoRefreshArchivedAudios, switchArchivedAutoFresh } from "../../../redux/JobModule/ArchivedPage/ArchivedAction";

function AutoRefreshArchivedCheckbox(props: any) {
  const dispatch = useAppDispatch();
  const autoRefreshState = useSelector((state: RootState) => state.ArchivedAudiosState.autoRefreshArchivedState);
  useEffect(() => {
    dispatch(autoRefreshArchivedAudios({}));
  }, [autoRefreshState.autoRefresh]);

  return null;
  //  (
  //   <div className="auto-refresh-checkbox h-100 gap-2 ">
  //     <SyncOutlined
  //       style={{
  //         fontSize: 15,
  //         visibility: autoRefreshState.loading ? "visible" : "hidden",
  //       }}
  //       spin
  //     />
  //     <Switch
  //       style={{ margin: "11px", fontSize: "15px", boxShadow: "none" }}
  //       size="default"
  //       defaultChecked={autoRefreshState.autoRefresh}
  //       onChange={(checked) => {
  //         dispatch(switchArchivedAutoFresh({ autoRefresh: checked }));
  //       }}
  //     />

  //     <span>Auto Refresh</span>
  //   </div>
  // );
}

export default AutoRefreshArchivedCheckbox;
